/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Info_SuccessInputs */

const es_tools_legajox_info_success = /** @type {(inputs: Tools_Legajox_Info_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información de Legajox obtenida`)
};

const en_tools_legajox_info_success = /** @type {(inputs: Tools_Legajox_Info_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox info retrieved`)
};

/**
* | output |
* | --- |
* | "Legajox info retrieved" |
*
* @param {Tools_Legajox_Info_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_info_success = /** @type {((inputs?: Tools_Legajox_Info_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Info_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_info_success(inputs)
	return en_tools_legajox_info_success(inputs)
});
export { tools_legajox_info_success as "tools.legajox.info_success" }